import { isModuloAtivo, nomeModulo } from './modulosLicenca';

const MODULO_POR_TIPO = {
  preVenda: 'ADD_PREVENDA',
  inventario: 'ADD_INVENTARIO',
};

export function contarPdvsAtivos(pdvs) {
  const lista = Array.isArray(pdvs) ? pdvs : [];
  return {
    caixas: lista.filter((p) => p.ativo && !p.zenPay && !p.autoAtendimento).length,
    autoAtendimento: lista.filter((p) => p.ativo && !p.zenPay && p.autoAtendimento).length,
    zenPay: lista.filter((p) => p.ativo && p.zenPay).length,
  };
}

export function normalizarRecursosPdv(recursos) {
  if (!recursos) {
    return {
      pdvsPermitidos: 1,
      autoAtendimentosPermitidos: 0,
      zenPayTerminaisPermitidos: 0,
    };
  }
  return {
    pdvsPermitidos: recursos.pdvsPermitidos ?? recursos.PdvsPermitidos ?? 1,
    autoAtendimentosPermitidos:
      recursos.autoAtendimentosPermitidos ?? recursos.AutoAtendimentosPermitidos ?? 0,
    zenPayTerminaisPermitidos:
      recursos.zenPayTerminaisPermitidos ?? recursos.ZenPayTerminaisPermitidos ?? 0,
  };
}

export function podeCadastrarPdvTipo(tipo, { uso, recursos, modulos }) {
  const limites = normalizarRecursosPdv(recursos);
  const contagem = uso || { caixas: 0, autoAtendimento: 0, zenPay: 0 };

  if (tipo === 'zenpay') {
    if (!isModuloAtivo(modulos, 'ADD_ZENPAY')) {
      return { ok: false, motivo: 'Módulo ZenPay não habilitado na licença.' };
    }
    if (contagem.zenPay >= limites.zenPayTerminaisPermitidos) {
      return {
        ok: false,
        motivo: `Limite de ${limites.zenPayTerminaisPermitidos} terminal(is) ZenPay atingido. Desative outro terminal ZenPay para ativar este.`,
      };
    }
    return { ok: true };
  }

  if (tipo === 'autoAtendimento') {
    if (!isModuloAtivo(modulos, 'ADD_AUTOATENDIMENTO') || limites.autoAtendimentosPermitidos <= 0) {
      return { ok: false, motivo: `Módulo ${nomeModulo('ADD_AUTOATENDIMENTO')} não habilitado na licença.` };
    }
    if (contagem.autoAtendimento >= limites.autoAtendimentosPermitidos) {
      return {
        ok: false,
        motivo: `Limite de ${limites.autoAtendimentosPermitidos} auto atendimento(s) atingido. Desative outro terminal de auto atendimento para ativar este.`,
      };
    }
    return { ok: true };
  }

  const modulo = MODULO_POR_TIPO[tipo];
  if (modulo && !isModuloAtivo(modulos, modulo)) {
    return { ok: false, motivo: `Módulo ${nomeModulo(modulo)} não habilitado na licença.` };
  }

  if (contagem.caixas >= limites.pdvsPermitidos) {
    return {
      ok: false,
      motivo: `Limite de ${limites.pdvsPermitidos} PDV(s) atingido. Desative outro terminal para ativar este.`,
    };
  }

  return { ok: true };
}

export function podeCadastrarAlgumPdv(ctx) {
  return ['caixa', 'zenpay', 'preVenda', 'autoAtendimento', 'inventario'].some(
    (tipo) => podeCadastrarPdvTipo(tipo, ctx).ok
  );
}
